import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const CalcIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect
        x="5.2474742"
        y="1.8703259"
        width="45.951485"
        height="53.706051"
        rx="10.916617"
        stroke="#000000"
        strokeWidth="2.90027"
        id="rect857"
      />
      <rect
        x="14.164434"
        y="13.427591"
        width="28.038921"
        height="6.0728951"
        rx="2.2599065"
        stroke="#000000"
        strokeWidth="2.90027"
        id="rect859"
      />
      <circle
        cx="15.629658"
        cy="33.802616"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle861"
        r="2.2170725"
      />
      <circle
        cx="28.223921"
        cy="33.802616"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle863"
        r="2.2170725"
      />
      <circle
        cx="40.818314"
        cy="33.802616"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle865"
        r="2.2170725"
      />
      <circle
        cx="15.629658"
        cy="43.899323"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle867"
        r="2.2170725"
      />
      <circle
        cx="28.223921"
        cy="43.899323"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle869"
        r="2.2170725"
      />
      <circle
        cx="40.818314"
        cy="43.899323"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.23667"
        id="circle871"
        r="2.2170725"
      />
    </SvgIcon>
  );
};

export default CalcIcon;
